import _extends from '../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.filter.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find-index.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import { __rest, __spreadArray, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { isArray, isFunction } from 'lodash';
import List from '../List/index.js';
import getItemNodeAndConfig from '../../utils/getItemNodeAndConfig.js';
import getRowKey from '../../utils/getRowKey.js';

function Select(props, ref) {
  var renderItem = props.renderItem,
    selectedRow = props.selectedRow,
    _a = props.selectType,
    selectType = _a === void 0 ? 'single' : _a,
    _b = props.rowKey,
    rowKey = _b === void 0 ? 'id' : _b,
    onItemClick = props.onItemClick,
    restProps = __rest(props, ["renderItem", "selectedRow", "selectType", "rowKey", "onItemClick"]);
  var listRef = useRef({});
  var handleItemClick = function handleItemClick(row, selected) {
    if (isFunction(onItemClick)) {
      onItemClick(row, selected);
    }
  };
  var handleInternalItemClick = function handleInternalItemClick(row, active) {
    // active为是否选中状态，更改选中状态需要去反选
    if (selectType === 'single') {
      if (active) {
        handleItemClick(row, null);
      } else {
        handleItemClick(row, row);
      }
    } else {
      var previousRows = isArray(selectedRow) ? __spreadArray([], selectedRow, true) : [];
      if (active) {
        var currentKey_1 = getRowKey(row, rowKey);
        var selected = previousRows.filter(function (x) {
          var key = getRowKey(x, rowKey);
          return currentKey_1 !== key;
        });
        handleItemClick(row, selected);
      } else {
        handleItemClick(row, __spreadArray(__spreadArray([], previousRows, true), [row], false));
      }
    }
  };
  var renderCustomItem = function renderCustomItem(row, index) {
    var currentRowKey = getRowKey(row, rowKey);
    // 单选
    if (selectType === 'single') {
      var selectedRowKey = getRowKey(selectedRow, rowKey);
      var active_1 = selectedRowKey === currentRowKey;
      var result_1 = renderItem(row, index, {
        active: active_1
      });
      var _a = getItemNodeAndConfig(result_1),
        node_1 = _a.node,
        config_1 = _a.config;
      return {
        node: node_1,
        config: __assign(__assign({}, config_1), {
          active: active_1
        })
      };
    }
    // 多选
    var previousRows = isArray(selectedRow) ? __spreadArray([], selectedRow, true) : [];
    var active = previousRows.findIndex(function (x) {
      var key = getRowKey(x, rowKey);
      return key === currentRowKey;
    }) > -1;
    var result = renderItem(row, index, {
      active: active
    });
    var _b = getItemNodeAndConfig(result),
      node = _b.node,
      config = _b.config;
    return {
      node: node,
      config: __assign(__assign({}, config), {
        active: active
      })
    };
  };
  // 向父组件暴露search方法
  useImperativeHandle(ref, function () {
    return {
      onSearch: listRef.current.onSearch
    };
  });
  return /*#__PURE__*/React.createElement(List, _extends({}, restProps, {
    rowKey: rowKey,
    ref: listRef,
    renderItem: renderCustomItem,
    onItemClick: handleInternalItemClick
  }));
}
var Select$1 = /*#__PURE__*/forwardRef(Select);

export { Select$1 as default };
